import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { SkeletonAnimation } from '../../skeleton-loader.types';

@Component({
  selector: 'cm-skeleton-section',
  standalone: true,
  imports: [],
  templateUrl: './skeleton-section.component.html',
  styleUrl: './skeleton-section.component.less',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SkeletonSectionComponent {
  public readonly animation = input<SkeletonAnimation>('shimmer');
}
